import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { connect as connectFormik } from 'formik';
import { withLocalize } from 'react-localize-redux';
import { domainActions } from '../../store/domainStore';
import PopupMultiSelectButton from '../common/popupMultiSelectButton';
import SelectOption from './selectOption';
import MarketingSection from '../marketingList/marketingSection';
import BbInput from '../styling/bbInput';
import { unicornAttributes } from "../../store/marketingListStore";

class SubjectWarnings extends React.Component {

    render() {
        return (
            <MarketingSection name={this.props.translate(this.props.warningType === 'positive' ? "Search.Marketing.RegisteredWarningInfo" : 'Search.Marketing.NotRegisteredWarningInfo')} isOpen={this.props.isOpen || false}>
                <BbInput type='custom' label={this.props.translate("Common.Warnings")} placeholder={{ type: 'column' }} custom={
                    <PopupMultiSelectButton
                        title={this.props.translate(this.props.warningType === 'positive' ? "Search.Marketing.RegisteredWarningInfo" : 'Search.Marketing.NotRegisteredWarningInfo')}
                        data={`warning-types`}
                        name={`warning-types`}
                        popupSize='large'
                        onClick={() => this.props.ensureDomainData(`warning-types`, { marketAttributes: unicornAttributes() })}
                        selection={this.props.formik.values.warnings[this.props.warningType]}
                        onScroll={(e) => this.onScroll(e)}
                        handleChange={(all, parent) => {
                            this.props.formik.setFieldValue(`warnings.${this.props.warningType}.all`, all)
                            this.props.formik.setFieldValue(`warnings.${this.props.warningType}.parent`, parent)
                        }}
                        splitOnlyParent={true}
                        treeExpanded={true}/>
                } />
                <BbInput type='radio' label={this.props.translate('Search.Marketing.ConditionType')} placeholder={{ type: 'column' }} 
                    options={[
                        { value: 'AND', label: 'Search.Common.ConditionAnd' },
                        { value: 'OR', label: 'Search.Common.ConditionOr' }
                    ]}
                    idFormat={(val) => `$radio-warnings-${this.props.warningType}-condition-${val}`}
                    checkedValue={this.props.formik.values.warnings[this.props.warningType].condition} 
                    callback={(val) => this.props.formik.setFieldValue(`warnings.${this.props.warningType}.condition`, val)}
                />
                <BbInput type='select-noformik' label={this.props.translate('Report.Common.History')} placeholder={{ type: 'column' }} 
                    formatOptionLabel={SelectOption}
                    onChange={(e) => this.props.formik.setFieldValue(`warnings.${this.props.warningType}.history`, e.value)}
                    options={this.getHistoryOptions()}
                    value={{
                        label: this.getHistoryTypeLabel(this.props.formik.values.warnings[this.props.warningType].history),
                        value: this.props.formik.values.warnings[this.props.warningType].history
                    }}
                />
            </MarketingSection>
        )
    }

    getHistoryTypeLabel(value) {
        if (["0", "3", "6", "9", "12", "24"].includes(value))
            return this.props.translate(`Search.Marketing.History.${value}`);
        else if (value === "max")
            return this.props.translate("Search.Marketing.History.Max")
        else
            return undefined;
    }

    getHistoryOptions() {
        return ["0", "3", "6", "9", "12", "24", "max"].map(
            x => { return { label: this.getHistoryTypeLabel(x), value: x }; }
        )
    }
}

export default withLocalize(connectFormik(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch),
)(SubjectWarnings)));